import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import image from "../static/icons/logo-color.png";
import { useHistory } from "react-router-dom";
import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { useAuth } from "../hooks/UseAuth";
import { getUserByFirebaseId } from "../services/firebase";

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

export const NavBar = () => {
  const auth = useAuth();
  let [userTypes, setUserTypes] = useState<string[]>([]);
  let authed = auth.currentUser ? auth.currentUser.uid : null;

  let history = useHistory();

  useEffect(() => {
    async function getPermissions() {
      const uid = auth.currentUser;
      const us = await getUserByFirebaseId(uid);
      if (!us) {
        return;
      }
      setUserTypes(us.user_types);
    }
    getPermissions();
  }, []);

  const handleLogOut = () => {
    auth.logout();
    history.push("/");
  };

  const handleLogin = () => {
    history.push("/login");
  };

  function AdminTabs() {
    if (
      // @ts-ignore
      !userTypes.includes("admin") ||
      // @ts-ignore
      !userTypes.includes("director")
    ) {
      return <></>;
    }
    return (
      <div className="flex flex-row sm:flex sm:space-x-8">
        <div className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
          <Link to="/admin">Admin</Link>
        </div>
      </div>
    );
  }

  function AdminMobileButtons() {
    if (
      // @ts-ignore
      !userTypes.includes("admin") ||
      // @ts-ignore
      !userTypes.includes("director")
    ) {
      return <></>;
    }
    return (
      <div className="pt-2 pb-4 space-y-1  border-b">
        <Disclosure.Button
          as="a"
          href="/admin"
          className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
        >
          Admin
        </Disclosure.Button>
      </div>
    );
  }

  function ManagerTabs() {
    // @ts-ignore
    if (!userTypes.includes("manager")) {
      return <></>;
    }
    return (
      <div className="flex flex-row sm:flex sm:space-x-8">
        <div className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
          <Link to="/users">Users</Link>
        </div>
      </div>
    );
  }

  function ManagerMobileButtons() {
    // @ts-ignore
    if (!userTypes.includes("manager")) {
      return <></>;
    }
    return (
      <div className="pt-2 pb-4 space-y-1  border-b">
        <Disclosure.Button
          as="a"
          href="/users"
          className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
        >
          Users
        </Disclosure.Button>
      </div>
    );
  }

  function DesignerTabs() {
    // @ts-ignore
    if (!userTypes.includes("designer")) {
      return <></>;
    }
    return (
      <div className="flex flex-row sm:flex sm:space-x-8">
        <div className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
          <Link to="/designs">Designs</Link>
        </div>
        <div className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
          <Link to="/fonts">Fonts</Link>
        </div>
        <div className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
          <Link to="/product-templates">Design Product Templates</Link>
        </div>
      </div>
    );
  }

  function DesignerMobileButtons() {
    // @ts-ignore
    if (!userTypes.includes("designer")) {
      return <></>;
    }
    return (
      <div className="pt-2 pb-4 space-y-1  border-b">
        <Disclosure.Button
          as="a"
          href="/designs"
          className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
        >
          Designs
        </Disclosure.Button>
        <Disclosure.Button
          as="a"
          href="/fonts"
          className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
        >
          Fonts
        </Disclosure.Button>
      </div>
    );
  }

  function SupportTabs() {
    // @ts-ignore
    if (!userTypes.includes("support")) {
      return <></>;
    }
    return (
      <div className="flex flex-row sm:flex sm:space-x-8">
        <div className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
          <Link to="/organizations">Organizations</Link>
        </div>
        <div className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium">
          <Link to="/product-catalog">Product Catalog</Link>
        </div>
      </div>
    );
  }

  function SupportMobileButtons() {
    // @ts-ignore
    if (!userTypes.includes("support")) {
      return <></>;
    }
    return (
      <div className="pt-2 pb-4 space-y-1 border-b">
        <Disclosure.Button
          as="a"
          href="/organizations"
          className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
        >
          Organizations
        </Disclosure.Button>
        <Disclosure.Button
          as="a"
          href="/catalog"
          className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
        >
          Vendor Product Catalog
        </Disclosure.Button>
        <Disclosure.Button
          as="a"
          href="#"
          className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
        >
          Projects
        </Disclosure.Button>
        <Disclosure.Button
          as="a"
          href="/product-catalog"
          className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
        >
          Internal Product Catalog
        </Disclosure.Button>
      </div>
    );
  }

  return (
    <Disclosure as="nav" className="bg-white shadow">
      {({ open }) => (
        <>
          <div className="mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex justify-between h-16">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex-shrink-0 flex items-center">
                  <Link to="/">
                    <img src={image} width="200" alt="Greekhouse Management" />
                  </Link>
                </div>
                <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                  <DesignerTabs />
                  <SupportTabs />
                  <ManagerTabs />
                  <AdminTabs />
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                <Menu as="div" className="ml-3 relative">
                  <div>
                    <Menu.Button className="bg-white rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                      Account
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <Menu.Item>
                        {({ active }) => (
                          <div
                            className={classNames(
                              active ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            {authed ? (
                              <div>
                                <button onClick={() => handleLogOut()}>
                                  Logout
                                </button>
                              </div>
                            ) : (
                              <div>
                                <button onClick={() => handleLogin()}>
                                  Login
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>
          <Disclosure.Panel className="sm:hidden">
            <SupportMobileButtons />
            <DesignerMobileButtons />
            <ManagerMobileButtons />
            <AdminMobileButtons />
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};
